"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PutBucketInventoryConfigurationInput_1 = require("./PutBucketInventoryConfigurationInput");
var PutBucketInventoryConfigurationOutput_1 = require("./PutBucketInventoryConfigurationOutput");
var ServiceMetadata_1 = require("./ServiceMetadata");
exports.PutBucketInventoryConfiguration = {
    metadata: ServiceMetadata_1.ServiceMetadata,
    name: "PutBucketInventoryConfiguration",
    http: {
        method: "PUT",
        requestUri: "/{Bucket}?inventory"
    },
    input: {
        shape: PutBucketInventoryConfigurationInput_1.PutBucketInventoryConfigurationInput
    },
    output: {
        shape: PutBucketInventoryConfigurationOutput_1.PutBucketInventoryConfigurationOutput
    },
    errors: []
};
//# sourceMappingURL=PutBucketInventoryConfiguration.js.map